import {axiosInterceptorInstance} from '@jobseeker/common-core/helpers';
import {STATUS} from '@jobseeker/common-core/constants';

import type {NotificationReturnType} from './types';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/${process.env.NEXT_PUBLIC_PREFIX_NOTIFICATION}/`
);

const count = async (path: string): Promise<NotificationReturnType> => {
  try {
    const response: any = await axios.get(`${path}`);

    if (response[STATUS] === 200) {
      return {
        count: response.data['count'],
      };
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const list = async (path: string): Promise<NotificationReturnType> => {
  try {
    const response: any = await axios.get(`${path}`);
    if (response[STATUS] === 200) {
      return {
        list: response?.data?.['list'],
      };
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const markRead = async (path: string): Promise<NotificationReturnType> => {
  try {
    const response = await axios.get(path);
    return response.data;
  } catch (error: any) {
    console.error(error);
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const notification = {
  count,
  list,
  markRead,
};

export default notification;
